import {
  FETCH_GALLERY,
  FETCH_MOMENTS
} from 'app/actions/types';

import {
  ADD_PHOTOSWIPE_ITEMS,
  ADD_SELECTION_ITEMS
} from 'shared/actions/types';

import {
  getGallery as fetchGallery,
  getMoments as fetchMoments
} from 'app/services/GalleryService';

export const getGallery = token => dispatch => {
  return fetchGallery(token)
  .then(gallery => {
    dispatch({
      type: FETCH_GALLERY,
      payload: gallery
    });

    return Promise.resolve();
  });
}

export const getMoments = (token, page = 1, perPage = 500) => dispatch => {
  return getMomentsPaginated(dispatch, token, page, perPage);
}

const getMomentsPaginated = (dispatch, token, page, perPage) => {
  return fetchMoments(token, page, perPage)
  .then(moments => {
    dispatch({
      type: FETCH_MOMENTS,
      payload: moments
    });

    dispatch({
      type: ADD_SELECTION_ITEMS,
      payload: moments
    });

    const psItems = getPhotoSwipeItems(moments);
    dispatch({
      type: ADD_PHOTOSWIPE_ITEMS,
      payload: {
        storyId: 0, // there are no stories here
        items: psItems
      }
    });

    if (moments.length < perPage) {
      return Promise.resolve();
    } else {
      return getMomentsPaginated(dispatch, token, page + 1, perPage);
    }
  });
}

const getPhotoSwipeItems = moments => {
  let psItems = [];

  for (let i = 0, l = moments.length; i < l; i++) {
    let m = moments[i];

    // no video support for now
    if (m.type && m.type.match(/video/)) {
      return;
    }

    psItems.push({
      id: m.id,
      position: m.position,
      src: m.print_url || m.preview_url,
      shareUrl: m.print_url || m.preview_url,
      fallbackShareUrl: m.share_url,
      filename: m.id.toString(),
      mimeType: m.type || 'image/jpeg',
      w: m.width,
      h: m.height,
      printStoreAccessible: !m.cutout && m.type != 'image/gif'
    });
  }

  return psItems;
}
